import { render, staticRenderFns } from "./TipiStudente.vue?vue&type=template&id=3ea18962&"
import script from "./TipiStudente.vue?vue&type=script&lang=ts&"
export * from "./TipiStudente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports